import React from "react";
import "../App.css";

const WhyChooseUs = () => {
  return (
    <div className="about-section padding-container">
      <div className="page-wrapper">
        <div className="about-us">

          <div
            className="about-1"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <h1>
              WHY CHOOSE <span className="orange-text">US</span>
            </h1>

            <p>
              <span className="orange-text">
                Trusted digital solutions crafted with precision and{" "}
              </span>
              <span>a commitment to delivering real business results.</span>
            </p>

            <br />

            <ul>
              <li>100% professional communication and support</li>
              <li>Tailored solutions based on client needs</li>
              <li>High-quality and timely project delivery</li>
              <li>Skilled and diverse in-house team</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
